// any index.js / server.js common things should be done here
// e.g
// - set moment locale
// - import some global css

import 'normalize.css'



// WEBPACK FOOTER //
// ./src/bootstrap.js